module.exports = __webpack_public_path__ + "fonts/Barlow-Bold.745090b3.woff";